import { useApiQuery } from "../../hooks/index.ts"
import { useT } from "../../i18n/index.tsx"
import { apkSizeLabel } from "../../lib/apk.ts"

/**
 * 스캐너 앱(APK) 내려받기 단추.
 *
 * 기기를 묶기 전에 앱부터 깔아야 하므로 설정의 기기 등록 카드 안에 둔다.
 *
 * `<a>` 로 두는 이유: 30MB 가 넘는 파일을 fetch 로 Blob 에 담으면 휴대폰 메모리를 먹는다.
 * 같은 출처 링크라 브라우저가 세션 쿠키를 함께 보내므로 인증은 그대로 걸린다.
 *
 * 아직 빌드하지 않아 파일이 없으면 **아무것도 그리지 않는다** — 눌러도 안 되는 단추를
 * 보여 주지 않는다.
 */
export function AppDownloadButton() {
  const t = useT()
  const apk = useApiQuery<{
    available: boolean
    sizeBytes: number | null
    variant: "release" | "debug" | null
    builtAt: string | null
    fileName: string | null
  }>("/api/app-scanner")

  if (!apk.data?.available) return null

  const { builtAt, fileName } = apk.data

  return (
    <div className="app-download">
      {/*
        주소에 빌드 시각을 달아 둔다. 같은 주소면 브라우저가 앞서 받은 파일을 그대로 다시
        줄 수 있어, 새로 빌드한 것을 시험하고 있다고 착각하게 된다.
      */}
      <a
        className="btn btn--primary btn--md"
        href={`/app/scanner.apk${builtAt ? `?v=${encodeURIComponent(builtAt)}` : ""}`}
        download={fileName ?? "returns-scanner.apk"}
      >
        <span>{t("scan.app.download", { size: apkSizeLabel(apk.data.sizeBytes) })}</span>
      </a>
      {/* 어느 빌드를 받는지 보여 준다 — 받은 파일 이름에도 같은 시각이 들어간다. */}
      {fileName ? <p className="app-download__note">{fileName}</p> : null}
      <p className="app-download__note">{t("scan.app.downloadNote")}</p>
      {/* 개발용 빌드가 걸려 있으면 알려 준다 — 크고 개발 도구가 들어 있다. */}
      {apk.data.variant === "debug" ? (
        <p className="app-download__note">{t("scan.app.downloadDebug")}</p>
      ) : null}
    </div>
  )
}
